import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const ArrowBackIcon: React.FC<IconProps> = props => (
  <Icon fill="currentColor" {...props}>
    <path d="M7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825Z" />
  </Icon>
)
